export interface OrdersFeatureRoutesConfig {
  path: string;
}

export const defaultOrdersFeatureRoutesConfig: OrdersFeatureRoutesConfig = {
  path: 'orders',
};
